
import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';
import commonSlice from './slices/commonSlice';
import persistSlice from './slices/persistSlice';

import { CommonSliceState } from './slices/commonSlice';
import { PersistSliceState } from './slices/persistSlice';

export type SetSliceStoreProps = (
  partial: State | Partial<State> | ((state: State) => State | Partial<State>),
  replace?: boolean | undefined,
  action?: string
) => any;

export type GetSliceStoreProps = () => State;

export type State = {
  commonSlice: CommonSliceState;
  persistSlice: PersistSliceState
};


const useStore = create<State>()(
  devtools(
    persist(
      (set, get) => ({
        commonSlice: commonSlice(set, get),
        persistSlice: persistSlice(set, get),
      }),
      {
        name: 'baitaticket',
        partialize: ({ persistSlice }) => ({ persistSlice }),
      }
    ),
    {
      name: 'baitaticket',
      anonymousActionType: "UPDATE_STATE",
      enabled: process.env.NODE_ENV === 'development',
    }
  )
);

export default useStore;
